import { BLAuth } from '@brandlive/client-auth';

export default new BLAuth(
	process.env.REACT_APP_PLATFORM_API_HOST as string,
	process.env.REACT_APP_LOGIN_URL as string,
	true,
	{ fromApp: 'Greenroom' }
);
